import { apiRequest } from ".";

export const getDevicesAPI = (data) => {
  return apiRequest({
    method: "get",
    url: `admin/devices`,
    queryParams: data,
  });
};
export const getDeviceDetailsAPI = (id) => {
  return apiRequest({
    method: "get",
    url: `admin/devices?device_id=${id}`,
    queryParams: {},
  });
};
export const getDeviceLogs = (id) => {
  return apiRequest({
    method: "get",
    url: `device/status/log/${id}`,
    queryParams: {},
  });
};

export const updateDeviceStatusAPI = (id, data) => {
  return apiRequest({
    method: "put",
    url: `devices/${id}`,
    data: data,
  });
};

export const getDeviceTempGraph = (id, { start_date, end_date, interval }) => {
  return apiRequest({
    method: "get",
    url: `device-temperature/${id}`,
    queryParams: { start_date, end_date, interval },
  });
};
export const deleteDeviceAPI = (id) => {
  return apiRequest({
    method: "delete",
    url: `devices/${id}`,
  });
};
